var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4658_755)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 48.5C37.2548 48.5 48 37.7548 48 24.5C48 11.2452 37.2548 0.5 24 0.5C10.7452 0.5 0 11.2452 0 24.5C0 37.7548 10.7452 48.5 24 48.5Z",
    fill: "#32BA8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8674 35.3264L30.2081 47.6671C40.4289 44.9415 47.9999 35.6292 47.9999 24.4999V23.8185L38.3091 14.8848L17.8674 35.3264Z",
    fill: "#0AA07B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.6056 29.8755C25.6655 30.9354 25.6655 32.7524 24.6056 33.8124L22.41 36.0079C21.3501 37.0679 19.533 37.0679 18.4731 36.0079L8.85794 26.3171C7.798 25.2572 7.798 23.4401 8.85794 22.3802L11.0535 20.1846C12.1135 19.1247 13.9305 19.1247 14.9904 20.1846L24.6056 29.8755Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.0095 13.1436C34.0694 12.0836 35.8864 12.0836 36.9464 13.1436L39.1419 15.3392C40.2019 16.3991 40.2019 18.2161 39.1419 19.2761L22.4858 35.8565C21.4259 36.9165 19.6088 36.9165 18.5489 35.8565L16.3533 33.6609C15.2934 32.601 15.2934 30.784 16.3533 29.724L33.0095 13.1436Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4658_755"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.77fcf8b8e3b92979e8f9d3451c7af4ac.svg";
export { ForwardRef as ReactComponent };